import React, { useState } from "react";

export default function HostelRulesModal({ isOpen, onAccept, onClose }) {
  const [checkedRules, setCheckedRules] = useState({
    rule1: false, rule2: false, rule3: false, rule4: false, rule5: false,
    rule6: false, rule7: false, rule8: false, rule9: false, rule10: false,
    rule11: false, rule12: false, rule13: false, rule14: false,
    rule15: false, rule16: false, rule17: false, rule18: false, rule19: false,
  });

  const hostelRules = [
    {
      id: "rule1",
      number: "1.",
      description: "Every hostel resident must carry his/her University Identity Card at all times."
    },
    {
      id: "rule2",
      number: "2.",
      description: "Hostel residents are not permitted to use powered vehicles within university campus. Hostel residents are encouraged to use bicycles to move within campus."
    },
    {
      id: "rule3",
      number: "3.",
      description: "Hostel timings must be strictly followed as per hostel policy."
    },
    {
      id: "rule4",
      number: "4.",
      description: "Violation of hostel timings or repeated late entry may result in fine/disciplinary action and cancellation of hostel allotment as per university policy."
    },
    {
      id: "rule5",
      number: "5.",
      description: "Attendance will be taken twice daily-once after the closing of the main hostel gate and again after the closing of the inner gate of the respective hostel. Students must be present during attendance."
    },
    {
      id: "rule6",
      number: "6.",
      description: "Filling leave form and rebate form is mandatory before leaving the hostel to go home. It is the responsibility of the hostel resident to inform their hostel leaving plan to their parents before leaving the hostel. Hostel/University administration will not be responsible if the student leaves the hostel without informing their parents and hostel administration."
    },
    {
      id: "rule7",
      number: "7.",
      description: "Hostel residents will never indulge in any act of indiscipline in the Hostel room, corridors and verandahs that would cause disturbance to the fellow residents."
    },
    {
      id: "rule8",
      number: "8.",
      description: "Hostel residents are responsible for their conduct and actions both inside and outside the hostel within the University campus."
    },
    {
      id: "rule9",
      number: "9.",
      description: "Appropriate and decent casual attire must be worn in the dining hall and other common areas of the hostel."
    },
    {
      id: "rule10",
      number: "10.",
      description: "Smoking, consumption of alcohol and use or possession of any intoxicating substances are strictly prohibited within the hostel premises. Any such activity will be treated as a serious violation of hostel rules and will be a punishable offence."
    },
    {
      id: "rule11",
      number: "11.",
      description: "Any damage to hostel property will be considered a punishable offence, and the cost of repair may be recovered from the student(s) found accountable for the damage. Recovery of damage done to hostel property will be collectively imposed upon all residents if enquiry is unable to identify specific individual(s) involved."
    },
    {
      id: "rule12",
      number: "12.",
      description: "Any health condition (psychological and physiological) that requires extra medical care is the responsibility of hostel residents and their parents."
    },
    {
      id: "rule13",
      number: "13.",
      description: "Every hostel resident has to pay all fees (academic and hostel fees) as per university schedule and take no dues from the account section to collect admit cards for the end semester exam."
    },
    {
      id: "rule14",
      number: "14.",
      description: "Keeping or using any prohibited / unauthorized extra bedding, furniture, or other hostel property in a hostel room shall be treated as a violation of the Hostel Rules. Any resident found in possession of such unauthorized items shall be liable to disciplinary action as per university policies."
    },
    {
      id: "rule15",
      number: "15.",
      description: "Submitting an Anti Ragging form through the link mentioned is mandatory at the time of hostel allotment. (https://www.antiragging.in/affidavit_registration_disclaimer.html)"
    },
    {
      id: "rule16",
      number: "16.",
      description: "Parents/Guardians can only visit their ward’s hostel but cannot stay with them in the hostel rooms."
    },
    {
      id: "rule17",
      number: "17.",
      description: "Hostel residents/Students are not allowed to move around residential areas (faculty and staff) within university campus."
    },
    {
      id: "rule18",
      number: "18.",
      description: "It is mandatory to vacate the hostel during the summer vacation, failure of which may lead to fine or disciplinary action as university policy."
    },
    {
      id: "rule19",
      number: "19.",
      description: "Submission of all the forms and undertaking given on hostel portal, along with hostel fee payment slip, two passport-size photographs, and a copy of the Identity Proof (student/parents/guardians), is mandatory at the time of hostel possession. Failure of which will lead to hostel allotment cancellation."
    }
  ];

  const checkedCount = Object.values(checkedRules).filter(Boolean).length;
  const allRulesChecked = checkedCount === hostelRules.length;

  // Toggle single rule check state
  const handleCheckChange = (ruleId) => {
    setCheckedRules((prev) => ({
      ...prev,
      [ruleId]: !prev[ruleId],
    }));
  };

  // Select All or Deselect All toggle handler
  const handleSelectAllToggle = () => {
    const nextState = {};
    const targetState = !allRulesChecked; // If all checked, deselect all; otherwise, select all.
    hostelRules.forEach((rule) => {
      nextState[rule.id] = targetState;
    });
    setCheckedRules(nextState);
  };

  const handleAccept = () => {
    if (allRulesChecked) {
      onAccept();
      // Reset checkboxes safely
      const resetState = {};
      hostelRules.forEach((r) => { resetState[r.id] = false; });
      setCheckedRules(resetState);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fadeIn">
      <div className="bg-white rounded-xl max-w-2xl w-full shadow-2xl border border-gray-200 overflow-hidden flex flex-col">
        
        {/* Banner Section */}
        <div className="bg-gradient-to-r from-green-600 to-emerald-700 text-white p-5">
          <h2 className="text-xl font-bold">Hostel Rules & Regulations</h2>
          <p className="text-green-100 text-xs mt-0.5">
            Review and check every box to unlock room allocation dashboard utilities.
          </p>
        </div>

        {/* Progress Tracker & Quick Actions Bar */}
        <div className="bg-gray-50 border-b border-gray-100 px-6 py-3 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <label className="flex items-center gap-2 cursor-pointer text-xs font-bold text-gray-800 select-none bg-white border border-gray-200 px-2.5 py-1 rounded shadow-sm hover:border-green-500 transition">
              <input
                type="checkbox"
                checked={allRulesChecked}
                onChange={handleSelectAllToggle}
                className="w-4 h-4 text-green-600 rounded border-gray-300 focus:ring-green-500 cursor-pointer"
              />
              <span>{allRulesChecked ? "Deselect All" : "Select All"}</span>
            </label>

            <div className="text-xs font-semibold text-gray-700">
              Rules Accepted: <span className="text-green-600 font-bold">{checkedCount}</span> / {hostelRules.length}
            </div>
          </div>

          <div className="w-32 bg-gray-200 h-2 rounded-full overflow-hidden">
            <div
              className="bg-green-600 h-full transition-all duration-300"
              style={{ width: `${(checkedCount / hostelRules.length) * 100}%` }}
            />
          </div>
        </div>

        {/* Compact Scrollable Rules Box */}
        <div className="p-5 max-h-[380px] overflow-y-auto space-y-2.5 bg-white">
          {hostelRules.map((rule) => (
            <div 
              key={rule.id} 
              className={`flex items-start gap-2.5 p-2.5 rounded-lg border transition ${
                checkedRules[rule.id] 
                  ? "bg-green-50/40 border-green-200" 
                  : "bg-white border-gray-100 hover:border-gray-200"
              }`}
            >
              <input
                type="checkbox"
                id={`modal-${rule.id}`}
                checked={checkedRules[rule.id] || false}
                onChange={() => handleCheckChange(rule.id)}
                className="w-4 h-4 mt-0.5 text-green-600 rounded border-gray-300 focus:ring-green-500 cursor-pointer"
              />
              <label htmlFor={`modal-${rule.id}`} className="flex-1 cursor-pointer select-none text-[11px]">
                <span className="font-bold text-green-700 mr-1.5">{rule.number}</span>
                <span className="text-gray-600 leading-relaxed">{rule.description}</span>
              </label>
            </div>
          ))}
        </div>

        {/* Disclaimer Warning Area */}
        <div className="p-3 bg-amber-50 border-t border-amber-100 px-6">
          <p className="text-[10px] text-amber-800 leading-normal">
            <span className="font-bold">Disclaimer Notice:</span> Your digital acceptance acts as a binding university signature on Hostel Accommodation Form-B. Violation of any rules listed above may lead directly to administrative suspension.
          </p>
        </div>

        {/* Footer Actions Panel */}
        <div className="p-4 bg-gray-50 border-t border-gray-200 flex justify-between gap-3 px-6">
          <button
            onClick={onClose}
            className="px-5 py-2 text-xs font-semibold text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleAccept}
            disabled={!allRulesChecked}
            className={`px-5 py-2 text-xs font-bold rounded transition-all shadow ${
              allRulesChecked
                ? "bg-green-600 text-white hover:bg-green-700 cursor-pointer transform active:scale-95"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          >
            {allRulesChecked ? "✓ Accept Rules & Continue" : "Acknowledge Rules to Proceed"}
          </button>
        </div>

      </div>
    </div>
  );
}